import { Resource } from './resource';

export class InterviewStatus extends Resource {
    name: string;
    value : string;
    label : string;
  }